import { createAction, props } from "@ngrx/store"
import { NotificationDto } from "./notifications.dtos"
import { Notification } from "./notifications.interfaces"

export const fetchNotifications = createAction(
    '[Notifications Module] fetch notifications'
)

export const fetchNotificationsFailed = createAction(
    '[Notifications Module] STATUS: fetch notifications failed'
)

export const fetchNotificationsSuccess = createAction(
    '[Notifications Module] STATUS: fetch notifications success',
    props<{notifications: Notification[]}>()
)


export const deleteNotification = createAction(
    '[Notifications Module] delete notification',
    props<{notificationId: string}>()
)

export const deleteNotificationFailed = createAction(
    '[Notifications Module] STATUS: delete notification failed'
)

export const deleteNotificationSuccess = createAction(
    '[Notifications Module] STATUS: delete notification success'
)



export const createNotification = createAction(
    '[Notifications Module] create notification',
    props<{notificationDto: NotificationDto}>()
)

export const createNotificationFailed = createAction(
    '[Notifications Module] STATUS: create notification failed'
)

export const createNotificationSuccess = createAction(
    '[Notifications Module] STATUS: create notification success'
)



export const uploadFile = createAction(
    '[Notifications Module] upload file',
    props<{file}>()
)

export const uploadFileFailed = createAction(
    '[Notifications Module] STATUS: upload file failed'
)

export const uploadFileSuccess = createAction(
    '[Notifications Module] STATUS: upload file success'
)